import React, { Dispatch as ReactDispatch } from 'react'
import { ColorParameters } from '../../types/parameters'

// Create Contexts
const State = React.createContext<Partial<ColorParameters>>({})
const Dispatch = React.createContext<ReactDispatch<Partial<ColorParameters>>>(() => {})

// Initial State
const init: Partial<ColorParameters> = {} // You can define the initial state values here if needed

// Reducer
const reducer = (state: Partial<ColorParameters>, nextState: Partial<ColorParameters>) => {
  const theme = {
    ...state,
    ...nextState
  } as Partial<ColorParameters>
  return theme
}

// Provider component
interface ProviderProps {
  children: React.ReactNode
}

const Provider: React.FC<ProviderProps> = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, init)

  return (
    <State.Provider value={state}>
      <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </State.Provider>
  )
}

// Export
export const Theme = {
  State,
  Dispatch,
  Provider
}
